import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
export function CTASection() {
  return <section id="anmeldung" className="py-32 bg-[#3b7780] relative overflow-hidden" data-id="element-140">
      {/* Abstract background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '40px 40px'
    }} data-id="element-141"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-142">
        <ScrollReveal variant="up" data-id="element-143">
          <div className="text-center mb-16" data-id="element-144">
            <h2 className="text-2xl md:text-6xl font-extrabold text-white mb-8 tracking-tight" data-id="element-145">
              Jetzt informieren und anmelden
            </h2>
            <p className="text-base sm:text-lg md:text-2xl text-[#59d0d4] font-medium leading-relaxed max-w-3xl mx-auto" data-id="element-146">
              Stärken Sie Ihre Kompetenz – sichern Sie sich jetzt Ihren Platz im
              Curriculum Zahnmedizin oder in einem unserer spezialisierten
              Weiterbildungsangebote!
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto" data-id="element-147">
          <ScrollReveal variant="left" delay={200} data-id="element-148">
            <div className="rounded-3xl overflow-hidden shadow-2xl aspect-[4/5] lg:aspect-auto lg:h-full" data-id="element-149">
              <img src="https://cdn.rawproductionsgmbh.de/2n/kontakt/kontakt.jpg" alt="Kontakt aufnehmen" className="w-full h-full object-cover" data-id="element-150" />
            </div>
          </ScrollReveal>

          <ScrollReveal variant="right" delay={300} data-id="element-151">
            <form className="bg-white p-10 md:p-12 rounded-3xl shadow-2xl w-full" data-id="element-152">
              <h3 className="text-2xl font-extrabold text-slate-700 mb-8 text-center tracking-tight" data-id="element-153">
                Kursplatz anfragen
              </h3>

              <div className="space-y-6" data-id="element-154">
                <div data-id="element-155">
                  <label htmlFor="name" className="block text-sm font-bold text-slate-500 mb-2" data-id="element-156">
                    Name / Praxis
                  </label>
                  <input type="text" id="name" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" placeholder="Dr. Max Mustermann" data-id="element-157" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-158">
                  <div data-id="element-159">
                    <label htmlFor="email" className="block text-sm font-bold text-slate-500 mb-2" data-id="element-160">
                      E-Mail Adresse
                    </label>
                    <input type="email" id="email" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" placeholder="praxis@beispiel.de" data-id="element-161" />
                  </div>
                  <div data-id="element-162">
                    <label htmlFor="phone" className="block text-sm font-bold text-slate-500 mb-2" data-id="element-163">
                      Telefon
                    </label>
                    <input type="tel" id="phone" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" placeholder="0123 456789" data-id="element-164" />
                  </div>
                </div>

                <div data-id="element-165">
                  <label htmlFor="course" className="block text-sm font-bold text-slate-500 mb-2" data-id="element-166">
                    Interesse an
                  </label>
                  <select id="course" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all bg-white font-medium text-slate-700" data-id="element-167">
                    <option data-id="element-168">Gesamtes Curriculum</option>
                    <option data-id="element-169">A-Kurs White Aesthetics</option>
                    <option data-id="element-170">B-Kurs Red Aesthetics</option>
                    <option data-id="element-171">C-Kurs Funktion</option>
                    <option data-id="element-172">D-Kurs Champions League</option>
                    <option data-id="element-173">Female Boss Workshop</option>
                    <option data-id="element-174">Alignertherapie</option>
                  </select>
                </div>

                <div data-id="element-175">
                  <label htmlFor="message" className="block text-sm font-bold text-slate-500 mb-2" data-id="element-176">
                    Nachricht
                  </label>
                  <textarea id="message" rows={4} className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700 resize-none" placeholder="Ihre Nachricht an uns..." data-id="element-177"></textarea>
                </div>

                <button type="button" className="w-full mt-6 bg-[#3b7780] hover:bg-[#2d5f66] text-white font-extrabold py-4 px-6 rounded-xl transition-all hover:scale-105 flex items-center justify-center gap-3 shadow-lg" data-id="element-178">
                  Jetzt Kursplan sichern <ArrowRightIcon className="w-5 h-5" data-id="element-179" />
                </button>
              </div>
              <p className="text-sm text-slate-400 mt-6 text-center font-medium" data-id="element-180">
                Unverbindliche Anfrage. Wir melden uns umgehend bei Ihnen mit
                weiteren Details.
              </p>
            </form>
          </ScrollReveal>
        </div>
      </div>
    </section>;
}